export function MainInfo() {
    return         <section className="py-1 text-light">
            <div className="container">
                <div className="row" style={{height: "100px"}}></div>
                <div className="row justify-content-left">
                    <div className="col-lg-7 justify-content-center">
                        <h1>Make It Work</h1>
                        <p className="lead">Isentropy℠ LLC is a Vermont-based software company started in 2013 with special expertise in Ethereum and Solana smart contract applications, AI integrations, distributed systems, and quantitative programming.
                        </p>
                    </div>
                    <div className="col-sm-4 text-center">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col">
                                    <img src="assets/blockchain.png" style={{height: "6rem"}} />
                                    <p className="nav-item">BLOCKCHAIN</p>
                                </div>
                                <div className="col">
                                    <img src="assets/distributed.png" style={{height: "6rem"}} />
                                    <p className="nav-item">DISTRIBUTED SYSTEMS</p>
                                </div>
                                <div className="col">
                                    <img src="assets/security.png" style={{height: "6rem"}} />
                                    <p className="nav-item">SECURITY</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

}